import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(advanced);
export const formatTime = (time, format = 'h:mmA') => {
    return dayjs.utc(dayjs(time)).local().format(format);
};
export const formatWholesalerCutoff = (time) => {
    if (time) {
        // Cutoff fields are instants whose intent is a Central wall-clock time.
        // The backend enforces them by reading hour/minute in America/Chicago at
        // the instant's own date (shipping.class.ts getOrderEstArrivalDate), so
        // display must do the same: take the Chicago wall-clock off the stored
        // instant, project it onto today's date in Chicago, then render in the
        // viewer's timezone. Re-anchoring the raw UTC clock onto today (the old
        // approach) drifted the shown time by an hour whenever the stored date
        // and today fell on opposite sides of a DST transition (PM-1757), and
        // disagreed with the cutoff the backend actually enforced.
        const chicagoWallClock = dayjs(time).tz('America/Chicago');
        const todayCutoff = dayjs().tz('America/Chicago')
            .hour(chicagoWallClock.hour())
            .minute(chicagoWallClock.minute())
            .second(0)
            .millisecond(0);
        return formatTime(todayCutoff.toISOString(), 'h:mm A z');
    }
    return 'N/A';
};
